import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../api/firebase/references";
import { QuestionnaireState } from "../../pages/procedureQuestionaire/types";
import { logError } from "../../utils/customLogger";
import { AppDispatch, DataState } from "../store/store";

const intialState: DataState<QuestionnaireState> = {
  loading: false,
  error: null,
  data: null,
};
export const formQuestionsSlice = createSlice({
  name: "formQuestionsSlice",
  initialState: intialState,
  reducers: {
    setFormQuestions(state: DataState<any>, action: PayloadAction<any>) {
      state.data = action.payload;
      state.error = null;
      state.loading = false;
    },
    setLoading(state: DataState<any>, action: PayloadAction<boolean>) {
      state.data = null;
      state.loading = action.payload;
      state.error = null;
    },
    setError(state: DataState<any>, action: PayloadAction<string>) {
      state.error = action.payload;
      state.data = null;
      state.loading = false;
    },
    resetFormQuestions(state: DataState<any>) {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const { setFormQuestions, setLoading, setError, resetFormQuestions } =
  formQuestionsSlice.actions;

export default formQuestionsSlice.reducer;

export const getAllQuestionsForOrder = (orderId: string) => {
  return async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const documentSnapshot = await FirestoreService.getDocument<any>(
        FirestoreDocumentReference.medicalPaOrderQuestionnaire(orderId),
      );

      dispatch(setFormQuestions(documentSnapshot));
    } catch (error) {
      logError(error as Error, "Error fetching form questions");
      dispatch(setError("Error fetching form questions"));
    }
  };
};
